const settingsItems = [
  { name: "accountSettings", title: "Account Settings" },
  { name: "billing", title: "Billing" },
  { name: "notification", title: "Notification" },
  { name: "support", title: "Help & Support" },
];
export default settingsItems;
